export class UserSecuritySettingModel {
    public id: number;
    public isMultiFactorAuthentication: boolean;
    public minimumPasswordLength: number;
    public passwordExpirationDays: number;
}
